<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-alert-decagram-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Peta Rawan Bencana</div>
            <div class="header-info-subtitle">{{ selectedCategory ? selectedCategory.label : "Memuat..." }}</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="pa-0 fill-height content-layer">
        <v-card
          class="ma-6 flex-grow-1 cyber-map-container overflow-hidden"
          style="
            min-height: 600px;
            position: relative;
            border: 1px solid rgba(1, 140, 116, 0.3);
          "
        >
          <div id="map" v-if="selectedCategory" ref="mapContainer"></div>

          <div class="map-hud pa-4" v-if="!isLoading">
            <template v-if="selectedCategory">
              <div class="white--text overline border-left-gold pl-2 mb-1">
                Indeks Bahaya
              </div>
              <div class="white--text text-h6 font-weight-black mb-0">
                {{ selectedCategory.label }}
              </div>
              <v-divider class="my-2" dark style="opacity: 0.1"></v-divider>

              <div class="d-flex align-center mb-1">
                <div
                  style="width: 12px; height: 12px; background: #ff0000"
                  class="mr-2 rounded-sm shadow-red"
                ></div>
                <span class="white--text caption">Bahaya Tinggi</span>
              </div>
              <div class="d-flex align-center mb-1">
                <div
                  style="width: 12px; height: 12px; background: #ffff00"
                  class="mr-2 rounded-sm shadow-yellow"
                ></div>
                <span class="white--text caption">Bahaya Sedang</span>
              </div>
              <div class="d-flex align-center mb-4">
                <div
                  style="width: 12px; height: 12px; background: #39ff14"
                  class="mr-2 rounded-sm shadow-green"
                ></div>
                <span class="white--text caption">Bahaya Rendah</span>
              </div>
              <v-divider class="my-2" dark style="opacity: 0.1"></v-divider>
              <div class="d-flex align-center">
                <v-icon x-small color="rgba(255,255,255,0.5)" class="mr-1"
                  >mdi-database</v-icon
                >
                <span
                  class="grey--text text--lighten-1"
                  style="font-size: 9px; letter-spacing: 1px"
                >
                  SUMBER: BPBD KABUPATEN BONDOWOSO
                </span>
              </div>
            </template>

            <v-autocomplete
              v-model="selectedCategory"
              :items="categories"
              item-text="label"
              return-object
              label="CARI KATEGORI..."
              solo
              flat
              hide-details
              background-color="#CFA22D"
              color="white"
              light
              class="cyber-search rounded-lg font-weight-black white--text"
              append-icon="mdi-magnify"
              @change="forceReloadWithCategory"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title class="caption text-uppercase font-weight-bold">
                    {{ item.label }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>

          <v-overlay
            :value="isLoading"
            absolute
            color="#001a16"
            opacity="0.95"
            style="z-index: 1000"
          >
            <div class="text-center">
              <v-progress-circular
                indeterminate
                color="#018c74"
                size="64"
                width="6"
              ></v-progress-circular>
              <div class="white--text mt-6 letter-spacing-2 font-weight-bold">
                SEDANG MEMUAT...
              </div>
            </div>
          </v-overlay>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    map: null,
    isLoading: false,
    selectedCategory: null,
    categories: [
      {
        id: "cuaca",
        label: "Bahaya Cuaca Ekstrem",
        file: "/images/petabahaya/1.CuacaEkstremGabungan.tif",
      },
      {
        id: "kekeringan",
        label: "Bahaya Kekeringan",
        file: "/images/petabahaya/2.KekeringanGabungan.tif",
      },
      {
        id: "banjir",
        label: "Bahaya Banjir",
        file: "/images/petabahaya/3.BanjirGabungan.tif",
      },
      {
        id: "gempa",
        label: "Bahaya Gempa",
        file: "/images/petabahaya/4.GempaGabungan.tif",
      },
      {
        id: "letusan_gunung",
        label: "Bahaya Letusan Gunung",
        file: "/images/petabahaya/5.LetusanGunungGabungan.tif",
      },
      {
        id: "tanah_longsor",
        label: "Bahaya Tanah Longsor",
        file: "/images/petabahaya/6.TanahLongsorGabungan.tif",
      },
      {
        id: "karhutla",
        label: "Bahaya Karhutla",
        file: "/images/petabahaya/7.KarhutlaGabungan.tif",
      },
      {
        id: "liki_faksi",
        label: "Bahaya Likuifaksi",
        file: "/images/petabahaya/8.LikuifaksiGabungan.tif",
      },
      {
        id: "banjir_bandang",
        label: "Bahaya Banjir Bandang",
        file: "/images/petabahaya/9.BanjirBandangGabungan.tif",
      },
    ],
    kecamatanBondowoso: [
      { name: "Bondowoso", lat: -7.921689294979885, lng: 113.81756094328874 },
      { name: "Tamanan", lat: -8.018072048237087, lng: 113.82756357565002 },
      { name: "Prajekan", lat: -7.786120785217414, lng: 113.96486224777608 },
      { name: "Maesan", lat: -8.018299294773632, lng: 113.74689330788594 },
      { name: "Ijen", lat: -8.033963010856981, lng: 114.15467115233702 },
      { name: "Wringin", lat: -7.824970438028706, lng: 113.7619882790644 },
      { name: "Cermee", lat: -7.830780257033462, lng: 114.05370751768591 },
      { name: "Pujer", lat: -7.97894945531689, lng: 113.8826302367591 },
      { name: "Wonosari", lat: -7.9099132844388915, lng: 113.89371023366478 },
      { name: "Tlogosari", lat: -8.022893959684017, lng: 113.96314971071446 },
      { name: "Tenggarang", lat: -7.932977903939168, lng: 113.84100254110953 },
      { name: "Tegalampel", lat: -7.883914634260387, lng: 113.84503995288026 },
      { name: "Tapen", lat: -7.876753018474332, lng: 113.9296514907763 },
      { name: "Taman Krocok", lat: -7.848265503277429, lng: 113.86353920218855 },
      { name: "Sumber Wringin", lat: -7.993137282729632, lng: 114.02427919307792 },
      { name: "Sukosari", lat: -7.936814362897345, lng: 113.94216984549949 },
      { name: "Binakal", lat: -7.90572845088647, lng: 113.73683563026233 },
      { name: "Pakem", lat: -7.897226558515125, lng: 113.70641728690539 },
      { name: "Klabang", lat: -7.812964463830379, lng: 113.90650279749401 },
      {
        name: "Jambesari Darus Sholah",
        lat: -7.983872438561754,
        lng: 113.84799742616411,
      },
      { name: "Grujugan", lat: -7.977741985649366, lng: 113.74556448002785 },
      { name: "Curahdami", lat: -7.918317638230219, lng: 113.7555163665245 },
      { name: "Botolinggo", lat: -7.906455185178147, lng: 114.02677959969358 },
    ],
  }),
  mounted() {
    this.checkStoredCategory();
  },
  methods: {
    forceReloadWithCategory(item) {
      if (!item) return;
      this.isLoading = true;
      sessionStorage.setItem("pending_category_id", item.id);
      window.location.reload();
    },

    checkStoredCategory() {
      const pendingId = sessionStorage.getItem("pending_category_id");
      if (pendingId) {
        const category = this.categories.find((c) => c.id === pendingId);
        if (category) {
          this.selectedCategory = category;
          sessionStorage.removeItem("pending_category_id");
        }
      } else {
        this.selectedCategory = this.categories[0];
      }

      if (this.selectedCategory) {
        this.$nextTick(() => {
          this.initMap();
        });
      }
    },

    async initMap() {
      try {
        this.isLoading = true;
        this.map = window.L.map("map", {
          zoomControl: false,
          attributionControl: false,
        }).setView([-7.9135, 113.8217], 11);

        window.L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution: "&copy; OpenStreetMap contributors",
        }).addTo(this.map);

        this.map.createPane("regionPane").style.zIndex = 400;
        this.map.createPane("rasterPane").style.zIndex = 450;

        await Promise.all([
          this.loadGeoJson(),
          this.loadRaster(this.selectedCategory.file),
        ]);

        this.addLabels();
      } catch (e) {
        console.error("Init Error:", e);
      } finally {
        this.isLoading = false;
      }
    },

    async loadRaster(url) {
      const resp = await fetch(`${url}?t=${Date.now()}`);
      const buf = await resp.arrayBuffer();
      const geo = await window.parseGeoraster(buf);
      new window.GeoRasterLayer({
        georaster: geo,
        opacity: 0.8,
        pane: "rasterPane",
        pixelValuesToColorFn: (v) =>
          v[0] <= 0
            ? "transparent"
            : v[0] <= 0.3
            ? "#39FF14"
            : v[0] <= 0.6
            ? "#FFFF00"
            : "#FF0000",
        resolution: 256,
      }).addTo(this.map);
    },

    async loadGeoJson() {
      const resp = await fetch("/images/35.11_kecamatan.geojson");
      const data = await resp.json();
      window.L.geoJson(data, {
        pane: "regionPane",
        style: {
          color: "#ffffff",
          weight: 2,
          opacity: 0.8,
          fillColor: "#ffffff",
          fillOpacity: 0.15,
        },
      }).addTo(this.map);
    },

    addLabels() {
      this.kecamatanBondowoso.forEach((l) => {
        window.L.marker([l.lat, l.lng], {
          icon: window.L.divIcon({
            className: "custom-label",
            html: `<span>${l.name}</span>`,
            iconSize: [100, 20],
          }),
          interactive: false,
        }).addTo(this.map);
      });
    },
  },
};
</script>


<style scoped>
:root {
  --bg-teal: #018c74;
  --bg-teal-dark: #016b62;
  --bg-teal-light: #8bcdc6;
  --bone-white: #f5f5f5;
  --bone-light: #fafafa;
  --text-primary: #2e2e2e;
  --accent-gold: #ffa726;
  --accent-teal: #018c74;
}

#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;
  background: var(--bg-teal-dark);
}


:deep(.custom-label span) {
  color: var(--bone-white);
  font-weight: bold;
  font-size: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  text-transform: uppercase;
  white-space: nowrap;
}

.map-hud {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 999;
  background: var(--bone-light) !important;
  backdrop-filter: blur(15px);
  border-left: 4px solid var(--accent-gold);
  border-radius: 0 12px 12px 0;
  width: 280px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  color: var(--text-primary) !important;
}
.gold--text {
  color: var(--accent-gold) !important;
}
.border-left-gold {
  border-left: 3px solid var(--accent-gold);
}
.letter-spacing-2 {
  letter-spacing: 2px;
}


:deep(.cyber-search.v-text-field--solo .v-input__control) {
  min-height: 44px !important;
  background: var(--bone-light) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
}
:deep(.cyber-search input) {
  color: var(--text-primary) !important;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
}
:deep(.v-autocomplete__content) {
  background: var(--bone-white) !important;
  border: 1px solid rgba(45, 138, 122, 0.3);
  border-radius: 12px !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  color: var(--text-primary) !important;
}
:deep(.v-autocomplete__content .v-list-item) {
  color: var(--text-primary) !important;
}
:deep(.v-autocomplete__content .v-list-item--active) {
  background: rgba(45, 138, 122, 0.15) !important;
  color: var(--accent-teal) !important;
}

@media (max-width: 768px) {
  .map-hud {
    width: 240px;
    left: 12px;
    border-left-width: 3px;
  }}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
